module.exports = __webpack_public_path__ + "img/5.075868e4.png";